export enum WeightImperialUnitsEnum {
    // grain = 'GR',
    ounce = 'OZ',
    pound = 'LB',
    //...
}
